import router from "./router";
import store from "./store";
import Router from "vue-router";
import i18n from "./i18n";

router.beforeEach(async (to, from, next) => {
  if (!(_.isNil(from.name) && to.name === "init")) {
    // init페이지 이외에서, 정상적인 native 접속인지 확인.
    if (store.state.native.smphMchtlUniqNo === "") {
      router.push({ name: "init" });
    } else if (to.query.siteCode !== undefined) {
      store.commit("setSiteCode", { siteCode: to.query.siteCode, isLogin: false });
      router.push({name:"main", params:{siteCode:"ogmmr", lang:"KOR"}});
      i18n.locale = store.state.lang = to.query.lang;
      return;
    }
  }

  // store.dispatch("actSiteCode", store.state.siteCode);
  // if (from.name == null && to.name == "main") {
  //   console.log("siteCode -->", to.params.siteCode);
  //   if (to.params.siteCode) {
  //     store.commit("setSiteCode", { siteCode: to.params.siteCode, isLogin: false });
  //     store.dispatch("ACT_EXEC_LOGOUT");
  //     store.commit("setMenu", to.params.siteCode);
  //     console.log("lang -->", to.params.lang);
  //     if (to.params.lang) {
  //       i18n.locale = store.state.lang = to.params.lang;
  //     } else {
  //       i18n.locale = store.state.lang = "ENG";
  //     }
  //   }

  //   store.dispatch("actCallBridge", "simpleLoginGoPage");
  //   return;
  // }

  const role = to.meta.roles;
  // const isUserPwdRegiYn = store.getters["isUserPwdRegiYn"];
  const isLogin = store.getters["isLogin"];
  nextPage = to.fullPath;

  if (role === undefined) {
    stepHistorySave(from, to);
    next();
  } else if (role.includes("login")) {
    if (!isLogin) {
      // next(`/login?redirect=${to.path}`);
      store.state.needLoginModalOpended = true;
      store.state.needLoginPath = to.path;
    } else if (role.includes("corp")) {
      // store.state.pageLoading = true;
      if (store.getters["isCorporationSubUser"]) {
        if (role.includes("master")) {
          next({ name: "errorPage", params: { type: "forMater" } });
        } else {
          stepHistorySave(from, to);
          next();
        }
      } else {
        stepHistorySave(from, to);
        next();
      }
    } else {
      // store.state.pageLoading = true;
      stepHistorySave(from, to);
      next();
    }
  } else {
    next(`/logins?redirect=${to.path}`);
  }
});

const stepHistorySave = (from, to) => {
  if (from.meta.step !== undefined && to.meta.step !== undefined) {
    if (from.meta.step < to.meta.step) {
      if (_.isEmpty(from.params)) {
        store.state.history.push({ name: from.name, parent: from.matched[from.matched.length - 2].name });
      } else {
        store.state.history.push({ name: from.name, parent: from.matched[from.matched.length - 2].name, params: from.params });
      }
    }
  } else if ("main|login".includes(to.name)) {
    store.state.history = [];
  }
};

router.afterEach(to => {
  store.state.pageLoading = false;

  let tmp = "";
  // let name = to.matched[to.matched.length - 1].parent.name;
  // console.log(to);

  if (store.state.menu) {
    for (const data of store.state.menu) {
      for (const sub of data.children) {
        if (sub.children) {
          for (const sub2 of sub.children) {
            for (let i = to.matched.length - 1; i > -1; i--) {
              if (sub2.name == to.matched[i].name) {
                tmp = sub2.title;
                break;
              }
            }
            // if (sub2.name == to.matched[to.matched.length - 1].parent.name) {            }
          }
        } else {
          for (let i = to.matched.length - 1; i > -1; i--) {
            if (sub.name == to.matched[i].name) {
              tmp = sub.title;
              break;
            }
          }
          // if (to.matched[to.matched.length - 1].name == sub.name) {          }
        }
      }
    }
  }
  store.state.menuTitle = tmp;
});

let nextPage = "";
router.onError(error => {
  console.error(error);
  if (error.name === "ChunkLoadError") {
    window.location.href = nextPage || "/";
  }
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
